import * as React from "react"
import styled from "styled-components"
import Box from "../box"
import Text from "../text"
import { Colors } from "src/theme"
import ProgressiveImage from "react-progressive-bg-image"
import { FetchSearchListingsSearchListings } from "src/generated/graphql"
import moment from "moment"
import { DEFAULT_SPACE_PICTURE } from "src/config/constants"

const StyledText = styled(Text as any)`
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const ListingCardWrapper = styled(Box as any)`
  flex-shrink: 0;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  background-color: ${Colors.white};
  border: ${props =>
    props.hasPremium ? `2px solid ${Colors.primary}` : `solid 1px ${Colors.lightGreyFaded}`};
  border-radius: 4px;
  height: 100%;
  &:hover {
    ${StyledText} {
      text-decoration: underline;
    }
  }
`

const ListingImage = styled(ProgressiveImage)`
  padding: 16px;
  background-size: cover;
  background-repeat: no-repeat;
  height: 208px;
`

const ListingDetailsWrapper = styled(Box as any)`
  margin: 12px 0px 0 0;
  justify-content: space-between;
  align-items: center;
`

const ListingTitleWrapper = styled(Box as any)`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 4px;
`

export const ListingIsPremium = styled(Text as any)`
  left: 26px;
  top: 24px;
  padding: 4px 6px;
  border-radius: 6px;
  background-color: ${Colors.white};
  font-weight: 600;
  background: ${Colors.primary};
  color: ${Colors.white};
`

type Listing = FetchSearchListingsSearchListings & { startingPrice: number }
interface Props {
  listing: Listing
}

const ListingCard = (props: Props) => {
  const { listing } = props
  const hasPremium =
    moment.unix(listing.premiumStart / 1000).isBefore(moment()) &&
    moment.unix(listing.premiumEnd / 1000).isAfter(moment())
  return (
    <ListingCardWrapper hasPremium={hasPremium}>
      {listing && listing.pictures && listing.pictures[0] && listing.pictures[0].url && (
        <ListingImage
          transition="all 1s linear"
          src={listing.pictures[0].url}
          placeholder={DEFAULT_SPACE_PICTURE}
        />
      )}

      <ListingDetailsWrapper>
        <div>
          <ListingTitleWrapper>
            <StyledText as="h3" fontSize={18} fontWeight={600}>
              {listing.title}
            </StyledText>
          </ListingTitleWrapper>
          {/* <Text color={Colors.textFaded}>
            {"Starting at "} ${listing.startingPrice} per month
          </Text> */}
          <Text color={Colors.textFaded}>
            {listing.startingPrice !== 0
              ? `Starting at $${listing.startingPrice} per month`
              : "Contact for Pricing!"}
          </Text>
        </div>
        {hasPremium && <ListingIsPremium>Featured</ListingIsPremium>}
      </ListingDetailsWrapper>
    </ListingCardWrapper>
  )
}

export default ListingCard
